/* NPX — Toast UI + mesaj unificat pentru limite (no <script>, safe) */
(function(){
  if (window.NPX_note) return; // deja există

  var STYLE_ID='npx-toast-style', ROOT_ID='npx-toast-root', Z=2147483647;

  function ensureStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var css=('#'+ROOT_ID+'{position:fixed;top:12px;left:50%;transform:translateX(-50%);z-index:'+Z+';display:flex;flex-direction:column;gap:8px;pointer-events:none}'
    +'.npx-toast{min-width:min(92vw,560px);max-width:min(92vw,560px);background:#111;color:#fff;border-radius:10px;padding:10px 14px;'
    +'box-shadow:0 10px 30px rgba(0,0,0,.25);font:500 14px/1.35 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;opacity:0;'
    +'transform:translateY(-8px);transition:opacity .18s ease,transform .18s ease;pointer-events:auto;display:flex;align-items:flex-start}'
    +'.npx-toast.show{opacity:1;transform:translateY(0)}'
    +'.npx-toast .txt{flex:1;white-space:pre-wrap}'
    +'.npx-toast button.close{margin-left:12px;border:0;background:transparent;color:inherit;font-size:18px;line-height:1;cursor:pointer;opacity:.8}'
    +'.npx-toast button.close:hover{opacity:1}'
    +'.npx-toast.warn{background:#2d2000;border:1px solid #f6c243}'
    +'.npx-toast.info{background:#0b2239;border:1px solid #6ab4ff}'
    +'.npx-toast.success{background:#0f291e;border:1px solid #4ad295}');
    var s=document.createElement('style'); s.id=STYLE_ID; s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  }

  function ensureRoot(){
    var r=document.getElementById(ROOT_ID);
    if (r) return r;
    var attach=function(){ var rr=document.getElementById(ROOT_ID); if (rr) return rr;
      rr=document.createElement('div'); rr.id=ROOT_ID; (document.body||document.documentElement).appendChild(rr); return rr; };
    return document.body ? attach() : (document.addEventListener('DOMContentLoaded', attach, {once:true}), null);
  }

  function rm(el){ if(!el) return; el.classList.remove('show'); setTimeout(function(){ el.remove(); }, 180); }

  window.NPX_note=function(message, opts){
    if(!message) return;
    opts=opts||{}; ensureStyle(); var root=ensureRoot();
    if(!root){ setTimeout(function(){ window.NPX_note(message, opts); }, 50); return; }
    var type=opts.type||'warn', timeout=Number.isFinite(opts.timeout)?opts.timeout:3200;
    var t=document.createElement('div'); t.className='npx-toast '+type;
    t.innerHTML='<div class="txt" role="status" aria-live="polite"></div><button class="close" aria-label="Închide">×</button>';
    t.querySelector('.txt').textContent=String(message);
    root.appendChild(t); requestAnimationFrame(function(){ t.classList.add('show'); });
    var timer=setTimeout(function(){ rm(t); }, timeout);
    t.querySelector('.close').addEventListener('click', function(){ clearTimeout(timer); rm(t); }, {passive:true});
  };

  // mesaj unificat pentru limite (folosit în handlePlus/mb_handlePlus/AddBulkQuantity/etc)
  if (!window.NPX_limitMsg){
    window.NPX_limitMsg=function(rem){
      if(!(Number.isFinite(rem)&&rem>=0)) return;
      var msg=(rem<=0)?'Ai atins limita — nu mai poți adăuga bucăți.':'Poți adăuga cel mult '+rem+' buc.';
      window.NPX_note && window.NPX_note(msg, { type:'warn', id:'limit-'+String(rem) });
    };
  }
})();
/* NPX — Mesaje inline lângă input (mobil + desktop + /cart) — v1 */
(function(){
  if (window.__npx_inline_msgs_v1) return; window.__npx_inline_msgs_v1 = true;

  var STYLE_ID='npx-inline-msg-style';
  var T_DEFAULT = 3200;

  /* ---------- stil ---------- */
  (function ensureStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      +'.npx-inline-msg{font:500 13px/1.35 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;border-radius:8px;padding:8px 10px;margin:8px 0 4px}'
      +'.npx-inline-msg.warn{background:#fff3cd;border:1px solid #f6c243;color:#5c4700}'
      +'.npx-inline-msg.info{background:#e8f3ff;border:1px solid #6ab4ff;color:#0b2239}'
      +'.npx-inline-msg .x{float:right;margin-left:8px;cursor:pointer;opacity:.7}'
      +'.npx-inline-msg .x:hover{opacity:1}';
    var s=document.createElement('style'); s.id=STYLE_ID; s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  })();

  /* ---------- util ---------- */
  function isInput(el){ return !!el && (el.matches?.('.article-quantity-input') || el.matches?.('input[name^="updates"]')); }
  function parseIntOr(v, def){ var n=parseInt(v,10); return Number.isFinite(n)?n:def; }
  function remainingFor(inp){
    if (!inp) return 0;
    var vals=[
      inp.dataset && inp.dataset.remaining,
      inp.getAttribute && inp.getAttribute('data-remaining'),
      inp.dataset && inp.dataset.max,
      inp.getAttribute && inp.getAttribute('max'),
      inp.dataset && inp.dataset.inv,
      inp.getAttribute && inp.getAttribute('data-inv')
    ];
    for (var i=0;i<vals.length;i++){
      var n=parseInt(vals[i],10); if (Number.isFinite(n)) return Math.max(0,n);
    }
    return 0;
  }

  /* găsește „ancora” unde plasăm mesajul */
  function findAnchor(inp){
    if (!inp) return null;

    // 1) MOBIL modal (#cart-content<ID>): mesajul DEASUPRA blocului cu input-uri
    var modal = inp.closest('.sticky-add-modal-content');
    if (modal){
      var align = modal.querySelector('.align-quantity-btn');
      if (align) return { parent: align.parentNode, ref: align, place: 'before' };
    }

    // 2) /cart + drawer: sub widget-ul de cantitate
    var cartWrap = inp.closest('.m-quantity, .m-quantity-input, .m-cart__qty, .cart-item-qty');
    if (cartWrap){
      return { parent: cartWrap.parentNode, ref: cartWrap, place: 'after' };
    }

    // 3) DESKTOP tabel: după „.quantity-btn” (un pic mai jos)
    var align2 = inp.closest('.variant_detail')?.querySelector('.align-quantity-btn');
    if (align2){
      var qb = align2.querySelector('.quantity-btn') || align2.firstElementChild || align2;
      return { parent: qb.parentNode, ref: qb, place: 'after' };
    }

    // fallback: chiar înaintea inputului
    return { parent: inp.parentNode, ref: inp, place: 'before' };
  }

  function insertMsg(anchor, text, type){
    if (!anchor || !anchor.parent || !anchor.ref) return null;

    // caută dacă există deja un mesaj lângă ancora asta
    var container = (function(){
      // încercăm frații imediat vecini
      var el;
      if (anchor.place === 'before'){
        el = anchor.ref.previousElementSibling;
      } else {
        el = anchor.ref.nextElementSibling;
      }
      if (el && el.classList && el.classList.contains('npx-inline-msg')) return el;
      return null;
    })();

    if (!container){
      container = document.createElement('div');
      container.className = 'npx-inline-msg '+(type||'warn');
      // inserează
      if (anchor.place === 'before'){
        anchor.parent.insertBefore(container, anchor.ref);
      } else {
        if (anchor.ref.nextSibling) anchor.parent.insertBefore(container, anchor.ref.nextSibling);
        else anchor.parent.appendChild(container);
      }
    } else {
      container.className = 'npx-inline-msg '+(type||'warn');
    }

    container.textContent = String(text||'');
    // buton închidere mic
    var x = document.createElement('span');
    x.className='x'; x.setAttribute('aria-label','Închide'); x.textContent='×';
    x.addEventListener('click', function(){ container.remove(); }, {passive:true});
    container.appendChild(x);

    // autohide
    clearTimeout(container.__npxTimer);
    container.__npxTimer = setTimeout(function(){ container.remove(); }, T_DEFAULT);

    return container;
  }

  /* ——— EXPUNE: mesaje inline pentru inputul curent ——— */
  function showInlineForInput(inp, msg, type){
    var a = findAnchor(inp);
    if (!a) return false;
    insertMsg(a, msg, type||'warn');
    return true;
  }

  // ținem minte „ultimul input relevant”
  var LAST = null;
  function setLastFrom(el){
    if (isInput(el)) { LAST = el; return; }
    // click pe +/− sau pe +box sau pe buton de treaptă → găsim inputul vecin
    var wrap = el && el.closest?.('.align-quantity-btn, .m-quantity, .m-quantity-input, .m-cart__qty, .cart-item-qty, .variant_detail, .sticky-add-modal-content');
    if (!wrap) return;
    var candidate = wrap.querySelector?.('.article-quantity-input, input[name^="updates"]');
    if (candidate) LAST = candidate;
  }

  document.addEventListener('focusin', function(e){
    setLastFrom(e.target);
  }, true);
  document.addEventListener('click', function(e){
    var t = e.target;
    var btn = t.closest?.('button[name="plus"],button[name="minus"],.set-par-btn, .mb-discount-btn-container button');
    if (btn) setLastFrom(btn);
  }, true);

  /* ——— Override NPX_limitMsg: preferă inline lângă inputul curent ——— */
  var orig_limit = window.NPX_limitMsg;
  window.NPX_limitMsg = function(rem, opts){
    var msg = (rem<=0)
      ? 'Ai atins limita — nu mai poți adăuga bucăți.'
      : 'Poți adăuga cel mult '+rem+' buc.';
    var target = (opts && (opts.inputEl || document.getElementById(opts.inputId))) || LAST || (document.activeElement && isInput(document.activeElement) ? document.activeElement : null);

    if (target && showInlineForInput(target, msg, 'warn')) {
      return;
    }
    // fallback (dacă nu găsim ținta)
    if (typeof window.NPX_note === 'function') window.NPX_note(msg, {type:'warn'});
    else if (typeof orig_limit === 'function') orig_limit(rem, opts);
  };

  /* ——— Mesaj și la tastare peste limită (nu doar la + / +box) ——— */

  // detectăm intenție de creștere
  document.addEventListener('keydown', function(e){
    var inp = e.target && e.target.closest && e.target.closest('.article-quantity-input, input[name^="updates"]');
    if (!inp) return;
    // marchez dacă tasta este o cifră / arrow up / pageup
    if (/^\d$/.test(e.key) || e.key === 'ArrowUp' || e.key === 'PageUp') inp.__npxGrowTry = true;
  }, true);
  document.addEventListener('paste', function(e){
    var inp = e.target && e.target.closest && e.target.closest('.article-quantity-input, input[name^="updates"]');
    if (!inp) return;
    var txt = (e.clipboardData && e.clipboardData.getData && e.clipboardData.getData('text')) || '';
    if (/\d/.test(txt)) inp.__npxGrowTry = true;
  }, true);

  document.addEventListener('input', function(e){
    var inp = e.target && e.target.closest && e.target.closest('.article-quantity-input, input[name^="updates"]');
    if (!inp) return;
    LAST = inp;

    var remain = remainingFor(inp);
    var raw = String(inp.value||'').replace(/[^\d]/g,'').replace(/^0+(?=\d)/,'');
    var n = parseInt(raw,10); if (!Number.isFinite(n)) n = 0;

    // dacă e cap=0 și userul încearcă să crească
    if (remain <= 0 && inp.__npxGrowTry && n > 0) {
      window.NPX_limitMsg(0, { inputEl: inp });
      inp.__npxGrowTry = false;
      return;
    }
    // dacă a depășit limita (după normalizarea altor gardieni poate fi deja tăiat)
    if (inp.__npxGrowTry && remain > 0 && n > remain) {
      window.NPX_limitMsg(remain, { inputEl: inp });
      inp.__npxGrowTry = false;
      return;
    }
    // reset flag când scade
    if (n <= remain) inp.__npxGrowTry = false;
  }, true);

})();

let parms = [];
// --- ținem minte cantitățile pe variantă (pentru butonul bulk) ---
const CheckPrms = (q, vId) => {
  if (parms.length > 0) {
    const item = parms.find((item) => item.id === vId);
    if (item) {
      item.quantity = q;
    } else {
      const newObject = { id: vId, quantity: q };
      parms.push(newObject);
    }
  } else {
    const newObject = { id: vId, quantity: q };
    parms.push(newObject);
  }
};
// === desktop: highlight price tiers ===
// === desktop: highlight price tiers (fără stiluri inline; doar clasă CSS) ===
const chnageActiveRow = (inputval, variant_id) => {
  const q = Math.max(0, parseInt(inputval, 10) || 0);

  const nodeList = document.querySelectorAll(
    `.priceCl${variant_id}[data-qty-interval]:not([data-qty-interval="null"])`
  );
  if (!nodeList || !nodeList.length) return;

  // curăță highlight-ul vechi
  nodeList.forEach((el) => el.classList?.remove('is-active'));

  // dacă e 0/gol -> nu evidenția nimic
  if (q <= 0) return;

  // extrage și sortează pragurile
  const tiers = Array.from(nodeList)
    .map((el) => ({ el, ceil: parseInt(el.getAttribute('data-qty-interval'), 10) }))
    .filter((t) => Number.isFinite(t.ceil))
    .sort((a, b) => a.ceil - b.ceil);

  if (!tiers.length) return;

  // alege tier-ul activ în funcție de cantitate
  let idx = 0;
  if (q <= tiers[0].ceil) {
    idx = 0;
  } else if (q >= tiers[tiers.length - 1].ceil) {
    idx = tiers.length - 1;
  } else {
    for (let i = 0; i < tiers.length - 1; i++) {
      if (q >= tiers[i].ceil && q < tiers[i + 1].ceil) { idx = i; break; }
    }
  }

  // aplică highlight
  tiers[idx].el.classList?.add('is-active');
};



/* === DESKTOP QTY BLOCK START — înlocuiește tot până la comentariul de "mobile script" === */

/* Helperi */
function norm(str){ return (str || '').toString().replace(/^0+(?=\d)/,''); }
function qty(str){ const n = parseInt(norm(str),10); return Number.isInteger(n) ? n : NaN; }
function setBtn(add_btn_id, n){
  const btn = add_btn_id ? document.getElementById(add_btn_id) : null;
  if (btn) btn.disabled = !(Number.isInteger(n) && n > 0);
}

/* Input typing (desktop) */
function checkQuantity(event, add_btn, vId) {
  if (!event || !event.target) return;
  event.target.value = norm(event.target.value);

  const n  = qty(event.target.value);
  const ok = Number.isInteger(n) && n > 0;

  setBtn(add_btn, n);
  CheckPrms(ok ? n : '', vId);
  chnageActiveRow(ok ? n : 0, vId);
 // <<< nou:
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();
}

/* Minus (desktop) — permite revenirea la 0 (gol) */
// --- Minus (desktop) — întotdeauna scrie valoarea ca string la final ---
const handleMinus = (input_id, variantId, add_btn) => {
  const input = document.getElementById(input_id);
  if (!input) return;

  // citește numărul curent
  const n0 = parseInt(String(input.value || '')
                .replace(/[^\d]/g, '')
                .replace(/^0+(?=\d)/, ''), 10);

  // dacă e NaN sau <=1 => trecem la 0, altfel scădem 1
  const next = (!Number.isFinite(n0) || n0 <= 1) ? 0 : (n0 - 1);

  // IMPORTANT: scriem întotdeauna ca string
  input.value = String(next);

  // normalizează după regulile globale (păstrează '0' ca '0')
  if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
  else { try { input.dispatchEvent(new Event('input', { bubbles:true })); } catch(_) {} }

  // UI + memorare
  setBtn(add_btn, next);
  CheckPrms(next > 0 ? next : '', variantId);
  chnageActiveRow(next, variantId);

  // butonul „Adaugă toate”
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();
  
};




/* Plus (desktop) */
/* Plus (desktop) — blocat când remaining=0, mesaj și fără modificări */
const handlePlus = (input_id, variantId, add_btn) => {
  const input = document.getElementById(input_id);
  if (!input) return;

  const raw = String(input.value || '').replace(/^0+(?=\d)/, '');
  const n0  = parseInt(raw, 10) || 0;

  // remaining prioritar -> data-max/max -> data-inv
  let remain = parseInt(
    input.dataset.remaining || input.getAttribute('data-remaining') ||
    input.dataset.max       || input.max ||
    input.dataset.inv       || input.getAttribute('data-inv') || '0',
    10
  );
  if (!Number.isFinite(remain) || remain < 0) remain = 0;

  // === IMPORTANT: când NU mai ai ce adăuga, NU crește, arată banner, ține 0 ===
  if (remain <= 0) {
    if (typeof window.NPX_limitMsg === 'function') window.NPX_limitMsg(0);
    input.value = '0';
    setBtn(add_btn, 0);
    chnageActiveRow(0, variantId);
    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
    return;
  }

  // dacă suntem deja la cap → nu creștem; coșul rămâne activ, doar anunțăm
  if (n0 >= remain) {
    if (typeof window.NPX_limitMsg === 'function') window.NPX_limitMsg(remain);
    setBtn(add_btn, n0);
    chnageActiveRow(n0, variantId);
    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
    return;
  }

  const next = Math.min((isNaN(n0) || n0 < 1 ? 1 : n0 + 1), remain);
  input.value = String(next);

  if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);

  setBtn(add_btn, next);                 // coș activ la >0
  CheckPrms(next, variantId);
  chnageActiveRow(next, variantId);
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();
};






/* +box / +6 (desktop) */
const AddBulkQuantity = (quantity, variantId, add_btn) => {
  const input = document.getElementById(`q${variantId}`);
  if (!input) return;

  const n0 = parseInt(String(input.value || '').replace(/[^\d]/g, '').replace(/^0+(?=\d)/, ''), 10) || 0;

  let remain = parseInt(
    input.dataset.remaining || input.getAttribute('data-remaining') ||
    input.dataset.max       || input.max ||
    input.dataset.inv       || input.getAttribute('data-inv') || '0',
    10
  );
  if (!Number.isFinite(remain) || remain < 0) remain = 0;

  const min  = +input.dataset.min || +input.min || 1;
  const want = n0 + (parseInt(quantity, 10) || 0);

  if (remain < min) {
    if (window.NPX_limitMsg) window.NPX_limitMsg(remain);
    setBtn(add_btn, n0);
    return;
  }

  const val = Math.max(min, Math.min(remain, want));
  input.value = String(val);

// ✅ NOU: normalizează + declanșează autosave-ul și toți listenerii legați de 'input'
  if (window.NPX_normalizeQtyById) {
    window.NPX_normalizeQtyById(`q${variantId}`);
  } else {
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
  }

  setBtn(add_btn, val);
  CheckPrms(val, variantId);
  chnageActiveRow(val, variantId);
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();

  if (val < want && window.NPX_limitMsg) window.NPX_limitMsg(remain);
};



// === Bulk add sigur — include DOAR inputurile >0; tratează 422; resetează DOAR rândurile trimise ===
window.AddBulkProductToCart = async function (e) {
  e?.preventDefault?.();
if (window.__npx_bulk_running) return;
window.__npx_bulk_running = true;

  const normalize = (v) => String(v || '').replace(/[^\d]/g, '').replace(/^0+(?=\d)/, '');
  const getQty = (inp) => {
    const raw = parseInt(normalize(inp.value), 10);
    if (!Number.isInteger(raw) || raw < 1) return 0;
    const min  = +inp.dataset.min  || +inp.min || 1;
    const max  = +inp.dataset.max  || +inp.max || 999;
    const step = +inp.dataset.step || +inp.step || 1;
    let q = Math.max(min, Math.min(max, raw));
    if (step > 1) q = Math.floor(q / step) * step; // rotunjire în jos la multiplu
    return Math.max(min, Math.min(max, q));
  };

  const bulkBtn = e?.currentTarget || document.querySelector('.bulk-add-cart-btn');
  if (bulkBtn) { bulkBtn.disabled = true; bulkBtn.classList.add('is-loading'); }

  // 1) Colectăm doar rândurile cu qty > 0, din DOM
  const rows = Array.from(document.querySelectorAll('.variant_detail'));
  const requests = [];

  for (const row of rows) {
    const form = row.querySelector('form');
    const idEl = form?.querySelector('input[name="id"]');
    if (!idEl) continue;

    const vId = parseInt(idEl.value, 10);
    const inp = row.querySelector(`#q${vId}`) || row.querySelector(`#mb-q${vId}`);
    if (!inp) continue;

    const qty = getQty(inp);
    if (qty < 1) continue; // esența: rândurile cu 0 NU intră

    const setProp = form.querySelector('input[name="properties[_set]"]')?.value;
    const label = row.querySelector('.set-link-lab')?.textContent?.trim() || ('#' + vId);

    requests.push({
      payload: { id: vId, quantity: qty, ...(setProp ? { properties: { _set: setProp } } : {}) },
      vId, inp, label,
      requested: parseInt(normalize(inp.value), 10) || qty
    });
  }

  if (!requests.length) {
  alert('Completează minimum o cantitate (>0).');
  if (bulkBtn) { bulkBtn.disabled = false; bulkBtn.classList.remove('is-loading'); }
  window.__npx_bulk_running = false;
  return;
}


  // 2) Trimitem pe rând, cu retry la 422 (cantitate sugerată)
  const added = [], adjusted = [], skipped = [];

  async function postOne(item) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (r.ok) return { ok: true };
    // extragem o cantitate sugerată din mesaj (ex: „Doar 6 disponibile”)
    let text = '';
    try { const j = await r.json(); text = (j?.description || j?.message || '') + ''; }
    catch { try { text = await r.text(); } catch { text = ''; } }
    const m = text.match(/(\d+)/g); const sug = m ? parseInt(m[0], 10) : null;
    return { ok: false, status: r.status, text, suggested: Number.isInteger(sug) ? sug : null };
  }

  for (const req of requests) {
    let res = await postOne(req.payload);
    if (res.ok) { added.push({ label: req.label, qty: req.payload.quantity }); continue; }

    if (res.status === 422 && res.suggested > 0 && res.suggested !== req.payload.quantity) {
      const retry = await postOne({ ...req.payload, quantity: res.suggested });
      if (retry.ok) {
        added.push({ label: req.label, qty: res.suggested });
        adjusted.push({ label: req.label, from: req.requested, to: res.suggested });
        continue;
      }
    }
    skipped.push({ label: req.label, reason: res.text || 'Stoc insuficient' });
  }

   // 3) Sincronizează UI (bulină + drawer)
  try {
    if (window.NetpackRefreshCart) window.NetpackRefreshCart({ afterAdd: added.length > 0, open: true });
    else {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:change'));
      document.dispatchEvent(new CustomEvent('foxkit:cart:refresh'));
    }
  } catch {}

  // 4) Forțează toate inputurile la '0' (STRING) înainte de reload + dezactivează butoanele
  document.querySelectorAll('.article-quantity-input').forEach(inp => {
    inp.value = '0';
    try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch {}
    const form = inp.closest('form');
    const vid  = form?.querySelector('input[name="id"]')?.value;
    if (vid) {
      const d = document.getElementById('add-btn'    + vid);
      const m = document.getElementById('mb-add-btn' + vid);
      if (d) d.disabled = true;
      if (m) m.disabled = true;
      try { sessionStorage.removeItem('npx_qty_' + vid); } catch {}
    }
  });

  // 4.1) Recalculează starea butonului "Adaugă toate"
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();

  // 4.2) loader off
  if (bulkBtn) bulkBtn.classList.remove('is-loading');
  window.__npx_bulk_running = false;

  // 5) Dacă s-a adăugat/ajustat ceva -> setăm flaguri și HARD reload; altfel, reactivăm butonul
  if (added.length || adjusted.length) {
    try { sessionStorage.setItem('npx_bulk_zero_all', '1'); } catch {}
    try { sessionStorage.setItem('npx_open_drawer_bulk', '1'); } catch {}
   if (location.pathname !== '/cart') location.reload();

  } else {
    if (bulkBtn) bulkBtn.disabled = false;
  }
};



/* NPX — Ține în pas butoanele de “Adaugă” (desktop+mobil) și “Adaugă toate” — canonical */
(function(){
  if (window.__npx_bulk_state_v2) return; window.__npx_bulk_state_v2 = true;

  function normalize(str){ return String(str || '').replace(/[^\d]/g,'').replace(/^0+(?=\d)/,''); }
  function isValid(inp){
    if (!inp) return false;
    const raw = normalize(inp.value);
    const n   = parseInt(raw, 10);
    const min = +inp.dataset.min || +inp.min || 1;
    return Number.isInteger(n) && n >= min;
  }

  function recalc(){
    const bulk = document.querySelector('.bulk-add-cart-btn');
    if (!bulk) return;
    const anyValid = Array.from(document.querySelectorAll('.article-quantity-input')).some(isValid);
    bulk.disabled = !anyValid;
  }
  // expune funcția pentru restul handlerelor (handlePlus/Minus, AddBulkQuantity etc.)
  window.NPX_recalcBulk = recalc;

  // Orice input în câmpurile de cantitate → actualizează butoanele de rând + butonul “Adaugă toate”
  document.addEventListener('input', (e) => {
    const inp = e.target.closest('.article-quantity-input');
    if (!inp) return;

    const form = inp.closest('form');
    const vId  = form?.querySelector('input[name="id"]')?.value;
    const n    = parseInt(normalize(inp.value), 10);
    const ok   = Number.isInteger(n) && n > 0;

    if (vId){
      const d = document.getElementById('add-btn'    + vId);
      const m = document.getElementById('mb-add-btn' + vId);
      if (d) d.disabled = !ok;
      if (m) m.disabled = !ok;
    }
    recalc();
  }, true);

  // Inițializări (la load și revenire din BFCache)
  window.addEventListener('DOMContentLoaded', recalc, { once: true });
  window.addEventListener('pageshow', recalc);
})();




/* === DESKTOP QTY BLOCK END === */


/* ================== mobile script strt =======================
const handleSeeMoreBtn = (content) => {
  document.getElementsByClassName(content)[0].classList.toggle("accordion-open");
};

const handleMobileCart = (cart, cart_content)=>{
  document.getElementById(cart).classList.add('open-cart')
  document.getElementById(cart_content).classList.add('visible')
}

const closeModal = (cart, cart_content, event)=>{
  document.getElementById(cart).classList.remove('open-cart')
  document.getElementById(cart_content).classList.remove('visible')
}

const mb_handleMinus = (input_id) => {
  const input = document.getElementById(input_id);
  const inputVal = parseInt(input.value) - 1;
  if (inputVal >= 0) {
    input.value = inputVal;
  }
};

const mb_handlePlus = (input_id) => {
  const input = document.getElementById(input_id);
  const inputVal = parseInt(input.value) + 1;
  input.value = inputVal;
};

const handleBulkQntyAdder = (input_id, qnty) => {
   const input = document.getElementById(input_id);
   input.value = qnty;
}
*/

// ================== mobile script strt =======================

/* === Cache & helpers pentru mobil (performant, puține reflow-uri) === */
const mbCache = new Map();
// helper: prima valoare întreagă finită din listă
function firstFinite(...vals){
  for (const v of vals){
    const n = parseInt(String(v), 10);
    if (Number.isFinite(n)) return n;
  }
  return NaN;
}

function mbVariantIdFromInputId(input_id){
  const m = (input_id || '').match(/\d+$/);
  return m ? m[0] : null;
}

function mbInitModal(variantId){
  if (!variantId) return null;
  if (mbCache.has(variantId)) return mbCache.get(variantId);

  const modal     = document.getElementById('cart-content' + variantId);
  if (!modal) return null;

  const input     = document.getElementById('mb-q' + variantId);
  const container = modal.querySelector('.mb-discount-btn-container');
  if (!container) return null;

  const buttons   = Array.from(container.querySelectorAll('button'));

  // pragurile din etichete: “4 -”, “5 +”, “10 +”
  const thresholds = buttons.map(b => {
    const raw = (b.querySelector('span')?.textContent || b.textContent || '').trim();
    const m = raw.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  });

const tiers = thresholds.map((n, i, arr) => ({
  btn: buttons[i],
  // folosit DOAR pentru highlight
  min: i === 0 ? 1 : n,
  max: i === arr.length - 1 ? Infinity : (arr[i + 1] - 1),
  // ce vrem efectiv să setăm în input când apăsăm butonul (ex: 9 / 10 / 20)
  want: i === 0 ? thresholds[0] : n
}));


  const state = { variantId, modal, input, container, tiers, activeIndex: -1, bound: false };
  mbCache.set(variantId, state);
  return state;
}

function mbSetActive(state, idx){
  if (!state || idx === state.activeIndex) return;
  if (state.activeIndex >= 0) state.tiers[state.activeIndex].btn.classList.remove('selected');
  state.tiers[idx].btn.classList.add('selected');
  state.activeIndex = idx;
}

function mbHighlight(state, qtyRaw){
  if (!state || !state.tiers.length) return;
  const q = Math.max(0, parseInt(qtyRaw, 10) || 0);

  // 0 -> selectăm primul tier ca default
  if (q <= 0) return mbSetActive(state, 0);

  // găsim tierul potrivit fără a atinge toate butoanele
  let idx = 0;
  for (let i = 0; i < state.tiers.length; i++){
    const t = state.tiers[i];
    if (q >= t.min && q <= t.max) { idx = i; break; }
    if (q >= t.min) idx = i;
  }
  mbSetActive(state, idx);
}

/* === helper: activează/dezactivează butonul „Adaugă în coș” (mobil) === */
function mb_setBtn(variantId){
  const inp = document.getElementById('mb-q' + variantId);
  const btn = document.getElementById('mb-add-btn' + variantId);
  if (!inp || !btn) return;

  const raw = (inp.value || '').replace(/^0+(?=\d)/, '');
  const n   = parseInt(raw, 10);
  const ok  = Number.isInteger(n) && n > 0;
  btn.disabled = !ok;
}

/* ====== UI mobil ====== */

// “vezi mai mult” pe mobil (accordion)
const handleSeeMoreBtn = (content, btn) => {
  const el = document.getElementsByClassName(content)[0];
  if (!el) return;

  const open = el.classList.toggle('accordion-open');

  // marchează butonul ca “deschis” pentru CSS (rotația SVG)
  if (btn) {
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
};


// deschidere modal mobil (cu bind o singură dată + highlight inițial)
const handleMobileCart = (cart, cart_content)=>{
  const cartEl = document.getElementById(cart);
  const contentEl = document.getElementById(cart_content);
  if (cartEl) cartEl.classList.add('open-cart');
  if (contentEl) contentEl.classList.add('visible');

  const variantId = (cart_content.match(/\d+$/) || [null])[0];
  const state = mbInitModal(variantId);
  if (!state) return;
  // normalizează qty curent la min/max/step (mobil)
 if (variantId && window.NPX_normalizeQtyById) window.NPX_normalizeQtyById('mb-q' + variantId);


 // asigură-te că inputul folosește limita reală (remaining) calculată de caps
(function syncRemainingMax(){
  const inp = document.getElementById('mb-q' + variantId);
  if (!inp) return;
  const rem = parseInt(
    inp.getAttribute('data-remaining') || inp.dataset.remaining || 
    inp.getAttribute('data-max') || inp.dataset.max || '', 10
  );
  if (Number.isFinite(rem) && rem > 0) {
    inp.dataset.max = String(rem);
    inp.setAttribute('data-max', String(rem));
  }
  // deja ai: mbHighlight(state, state.input?.value || 0);
if (typeof window.NPX_updateMobileTotal === 'function') window.NPX_updateMobileTotal(variantId);

})();

 mb_setBtn(variantId);
mbHighlight(state, state.input?.value || 0);


  if (!state.bound){
    // un singur listener pe input (taste & change)
    if (state.input){
      state.input.addEventListener('input',  () => {
        mbHighlight(state, state.input.value);
        mb_setBtn(variantId);
      }, { passive: true });

      state.input.addEventListener('change', () => {
        mbHighlight(state, state.input.value);
        mb_setBtn(variantId);
      }, { passive: true });
    }

    // delegare: un singur click listener pe containerul de butoane
    if (state.container){
state.container.addEventListener('click', (e) => {
  const btn = e.target.closest('button');
  if (!btn || !state.input) return;
  const i = state.tiers.findIndex(t => t.btn === btn);
  if (i < 0) return;

  // setează pragul (ex: 9 / 10 / 20), respectând remaining + step
  handleBulkQntyAdder(state.input.id, state.tiers[i].want);
}, { passive: true });

    }

    state.bound = true;
  }

  // highlight inițial (inclusiv când qty este 0)
  mbHighlight(state, state.input?.value || 0);
};

// închidere modal mobil
const closeModal = (cart, cart_content, event)=>{
  const cartEl = document.getElementById(cart);
  const contentEl = document.getElementById(cart_content);
  if (cartEl) cartEl.classList.remove('open-cart');
  if (contentEl) contentEl.classList.remove('visible');
};

// --- MINUS (permite revenirea la gol = 0) ---
window.mb_handleMinus = function (input_id) {
  const inp = document.getElementById(input_id);
  if (!inp) return;

  const variantId = (input_id.match(/\d+$/) || [null])[0];
  const n = parseInt(String(inp.value).replace(/^0+(?=\d)/,''), 10);

  if (isNaN(n) || n <= 1) {
    inp.value = '0';                                   // ⬅️ 0 ca string
    if (typeof mb_setBtn === 'function') mb_setBtn(variantId);
    const state = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
    if (state) mbHighlight(state, 0);
    if (typeof window.NPX_recalcBulk === 'function') window.NPX_recalcBulk();
    return;
  }

  inp.value = String(n - 1);
  if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
  if (typeof mb_setBtn === 'function') mb_setBtn(variantId);
  const state = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
  if (state) mbHighlight(state, inp.value);
  if (typeof window.NPX_recalcBulk === 'function') window.NPX_recalcBulk();
};






// click pe un tier de preț mobil (mută cantitatea, normalizează și highlight)
// click pe un tier de preț mobil (setează qty dar respectă remaining = inv - inCart)





//========================= mobile script end===========================



/* NPX — Reset qty la '0' imediat după submit (desktop + mobil) + refresh drawer */
(function () {
  if (window.__npx_row_submit_reset_v1) return;
  window.__npx_row_submit_reset_v1 = true;

  // Rulăm în faza de captură, dar NU prevenim submit-ul — lăsăm tema să trimită payload-ul.
  document.addEventListener('submit', function (e) {
    const form = e.target?.closest('.variant_detail form, .variant-tabel form, .product-card-form, .product-form');
    if (!form) return;

    // lucrăm doar pentru formularele din tabelul de variante
    if (!form.closest('.variant_detail, .variant-tabel, [data-vtable-root]')) return;

    const idEl  = form.querySelector('input[name="id"]');
    if (!idEl) return;
    const vId   = idEl.value;

    const qtyEl = form.querySelector('#q' + vId) ||
                  form.querySelector('#mb-q' + vId) ||
                  form.querySelector('input.article-quantity-input');

    // dacă nu avem qty sau e 0/invalid, ieșim (click-guard-ul tău deja blochează astfel de cazuri)
    const raw = String(qtyEl?.value || '').replace(/^0+(?=\d)/, '');
    const n   = parseInt(raw, 10);
    if (!(Number.isInteger(n) && n > 0)) return;

    // După ce tema citește valorile, resetăm foarte repede UI-ul (fără a afecta request-ul deja pornit)
    requestAnimationFrame(() => {
      setTimeout(() => {
        // 1) Setează '0' ca STRING în inputul de pe rând (desktop/mobil)
        if (qtyEl) {
          qtyEl.value = '0';
          try { qtyEl.dispatchEvent(new Event('input', { bubbles: true })); } catch(_) {}
        }

        // 2) Dezactivează butoanele "Adaugă" de pe rând
        const dBtn = document.getElementById('add-btn'    + vId);
        const mBtn = document.getElementById('mb-add-btn' + vId);
        if (dBtn) dBtn.disabled = true;
        if (mBtn) mBtn.disabled = true;

        // 3) Curăță state local & highlight
        try { CheckPrms('', vId); } catch(_){}
        try { chnageActiveRow(0, vId); } catch(_){}
        try { sessionStorage.removeItem('npx_qty_' + vId); } catch(_){}

        // 4) Recalculează butonul „Adaugă toate”
        if (window.NPX_recalcBulk) window.NPX_recalcBulk();

        // 5) Sincronizează bulina și deschide drawer-ul
        try {
          if (window.NetpackRefreshCart) {
            window.NetpackRefreshCart({ afterAdd: true, open: true });
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:change'));
            document.dispatchEvent(new CustomEvent('foxkit:cart:refresh'));
          }
        } catch(_){}
      }, 60); // mic delay ca să nu „furăm” payload-ul din submit
    });
  }, true);
})();


// ------------------- Filtering Tabel Data Javascript Start -------------------

// Toggle all checkboxes when "All" is clicked
function toggleAllCheckbox(allCheckbox) {
  const checkboxes = document.querySelectorAll(".exampleCheckbox");

  // If "All" is checked, clear other checkboxes
  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  if (allCheckbox.checked) {
    showAllItems(); // Show all variants when "All" is checked
  }
}

// Filter based on selected checkboxes
function filterByCheckbox() {
  const allCheckbox = document.getElementById("allCheckbox");
  const checkboxes = document.querySelectorAll(".exampleCheckbox");
  let selectedValues = [];

  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      selectedValues.push(checkbox.value); // Store checked values
      console.log(checkbox.value);
    }
  });

  // If any checkbox is selected, uncheck "All"
  if (selectedValues.length > 0) {
    allCheckbox.checked = false;
  }

  // Apply the filter based on the selected checkboxes
  filterItems(selectedValues);
}

// Show all variants if "All" is selected
function showAllItems() {
  const variantDetails = document.querySelectorAll(".variant_detail");
  variantDetails.forEach((variant) => {
    variant.style.display = "table-row"; // Show all variants
  });
}

// Filter variants based on selected checkboxes
function filterItems(selectedValues) {
  const variantDetails = document.querySelectorAll(".variant_detail");

  variantDetails.forEach((variant) => {
    // const exampleText = variant.querySelector(".variant-example").innerText;
    const exampleText = variant.innerText;

    // Show variant if it matches any of the selected checkbox values
    if (
      selectedValues.length === 0 ||
      selectedValues.some((value) => exampleText.includes(value))
    ) {
      variant.style.display = "table-row"; // Show matching variant
    } else {
      variant.style.display = "none"; // Hide non-matching variant
    }
  });
}
// =================== Price Filter js ===================
// Robust: nu presupune simbol de monedă; acceptă „lei”, „RON”, spații, puncte sau virgule
function filterByPrice() {
  const minEl = document.getElementById("minPrice");
  const maxEl = document.getElementById("maxPrice");

  // dacă nu există controllerele în pagină, ieșim silențios
  if (!minEl || !maxEl) return;

  const minPrice = parseFloat((minEl.value || '').replace(',', '.')) || 0;
  const maxPrice = parseFloat((maxEl.value || '').replace(',', '.')) || Infinity;

  // actualizează afișajele dacă există
  const minOut = document.getElementById("minPriceValue");
  const maxOut = document.getElementById("maxPriceValue");
  if (minOut) minOut.textContent = isFinite(minPrice) ? String(minPrice) : '0';
  if (maxOut) maxOut.textContent = isFinite(maxPrice) ? String(maxPrice) : '∞';

  // helper: extrage număr din text (ex: "1.234,56 lei" -> 1234.56)
  const parsePriceNumber = (txt) => {
    const s = String(txt || '').replace(/[^\d.,-]/g, ''); // păstrăm doar cifre/.,-
    if (!s) return NaN;
    const lastDot  = s.lastIndexOf('.');
    const lastComm = s.lastIndexOf(',');
    const lastSep  = Math.max(lastDot, lastComm);

    let num = s;
    if (lastSep >= 0) {
      const intPart = s.slice(0, lastSep).replace(/[.,]/g, '');
      const decPart = s.slice(lastSep + 1);
      num = intPart + '.' + decPart;  // normalizăm la punct ca separator zecimal
    } else {
      num = s.replace(/[^\d-]/g, '');
    }
    const v = parseFloat(num);
    return isNaN(v) ? NaN : v;
  };

  const rows = document.querySelectorAll(".variant_detail");
  rows.forEach((row) => {
    // căutăm întâi <span class="rjnxt-price"> din interiorul .price-cell; dacă nu există, luăm textul celulei
    const priceNodes = row.querySelectorAll('.price-cell .rjnxt-price, .price-cell');
    let matches = false;

    priceNodes.forEach((node) => {
      const raw = (node.textContent || '').trim();
      if (!raw || raw === '-' ) return;
      const price = parsePriceNumber(raw);
      if (Number.isFinite(price) && price >= minPrice && price <= maxPrice) {
        matches = true;
      }
    });

    row.style.display = matches ? "table-row" : "none";
  });
}



/*
// ===== Sync cart UI after Back/Forward (bfcache) =====
(function () {
  function money(cents) {
    try {
      if (window.MinimogTheme?.Currency?.formatMoney) {
        return window.MinimogTheme.Currency.formatMoney(cents);
      }
      if (window.Shopify?.formatMoney) {
        const fmt = window.Shopify.money_format || "{{amount}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (_) {}
    return (cents / 100).toLocaleString("ro-RO", {
      style: "currency",
      currency: "RON",
      minimumFractionDigits: 2
    }).replace("RON", "lei");
  }

  function refreshCartUI(opts = {}) {
    const { afterAdd = false, settle = false, allowClear = true, tries = 0 } = opts;

    const ensureMoney = (cents) => {
      try {
        if (window.MinimogTheme?.Currency?.formatMoney) {
          return window.MinimogTheme.Currency.formatMoney(cents);
        }
        if (window.Shopify?.formatMoney) {
          const fmt = window.Shopify.money_format || "{{amount}}";
          return window.Shopify.formatMoney(cents, fmt);
        }
      } catch (_) {}
      return (cents / 100).toLocaleString("ro-RO", {
        style: "currency",
        currency: "RON",
        minimumFractionDigits: 2
      }).replace("RON", "lei");
    };
    const moneyFn = (typeof money === "function") ? money : ensureMoney;

    fetch("/cart.js", { cache: "no-store" })
      .then(r => r.json())
      .then(cart => {
        const isEmpty  = cart.item_count === 0;
        const hasShell = document.querySelector("[data-minimog-cart-items], .m-cart__items");

        const containers = document.querySelectorAll(
          "[data-minimog-cart-items], .m-cart__items, [data-minimog-cart-empty], .m-cart-empty, .m-cart__empty, .cart-empty"
        );
        if (!containers.length && tries < 8) {
          setTimeout(() => refreshCartUI({ ...opts, tries: tries + 1 }), 120);
          return;
        }

        if ((afterAdd || settle) && isEmpty && tries < 3) {
          setTimeout(() => refreshCartUI({ ...opts, tries: tries + 1 }), 200);
          return;
        }

        const bubble = document.querySelector(".m-cart-count-bubble");
        if (bubble) {
          bubble.textContent = cart.item_count;
          bubble.classList.toggle("m:hidden", isEmpty);
        }

        const itemsEls = document.querySelectorAll("[data-minimog-cart-items], .m-cart__items");
        const emptyEls = document.querySelectorAll("[data-minimog-cart-empty], .m-cart-empty, .m-cart__empty, .cart-empty");
        itemsEls.forEach(el => { el.style.display = isEmpty ? "none" : ""; });
        emptyEls.forEach(el => { el.style.display = isEmpty ? "" : "none"; });

        if (!isEmpty && hasShell && window.jQuery) {
          let $items   = $("[data-minimog-cart-items]");
          let selector = "[data-minimog-cart-items] > *";
          if (!$items.length) {
            $items   = $(".m-cart__items").first();
            selector = ".m-cart__items > *";
          }
          if ($items.length) {
            $items.load(window.location.href + " " + selector);
          }
        } else if (hasShell && allowClear) {
          document.querySelectorAll("[data-minimog-cart-items], .m-cart__items")
            .forEach(el => { el.innerHTML = ""; });
        }

        const subtotalText = moneyFn(cart.total_price);
        const subtotalBox  = document.querySelector("[data-cart-subtotal]");
        if (subtotalBox) {
          subtotalBox.classList.toggle("m:hidden", isEmpty);
          if (isEmpty) {
            subtotalBox.setAttribute("hidden", "hidden");
            subtotalBox.style.display = "none";
          } else {
            subtotalBox.removeAttribute("hidden");
            subtotalBox.style.display = "";
          }
          const priceEl = subtotalBox.querySelector("[data-cart-subtotal-price], .m-cart__subtotal--price");
          if (priceEl) priceEl.textContent = subtotalText;
        }
        document.querySelectorAll(".m-cart__subtotal--price").forEach(el => { el.textContent = subtotalText; });

        document.querySelectorAll(
          '[data-minimog-cart-checkout], .m-cart-checkout, .m-cart__footer a, .m-cart__footer button, a[href="/checkout"]'
        ).forEach(btn => {
          if ("disabled" in btn) btn.disabled = isEmpty;
          btn.setAttribute("aria-disabled", String(isEmpty));
          btn.classList.toggle("is-disabled", isEmpty);
          btn.classList.toggle("disabled", isEmpty);
        });
      })
      .catch(console.error);
  }

  function fromBFCache(e) {
    const nav = performance.getEntriesByType?.("navigation")?.[0];
    return e?.persisted || (nav && nav.type === "back_forward");
  }

  window.addEventListener("pageshow", (e) => {
    if (fromBFCache(e)) {
      refreshCartUI({ settle: true, allowClear: false });
      setTimeout(() => refreshCartUI({ settle: true, allowClear: true }), 400);
    } else {
      refreshCartUI({ allowClear: true });
    }
  });

  document.addEventListener("visibilitychange", () => {
    const nav = performance.getEntriesByType?.("navigation")?.[0];
    if (document.visibilityState === "visible" && nav && nav.type === "back_forward") {
      refreshCartUI({ settle: true, allowClear: false });
      setTimeout(() => refreshCartUI({ settle: true, allowClear: true }), 400);
    }
  });

  window.addEventListener("popstate", () => {
    refreshCartUI({ settle: true, allowClear: false });
    setTimeout(() => refreshCartUI({ settle: true, allowClear: true }), 400);
  });

  // === EXPOSE to window (pentru onclick="...") ===
  window.NetpackRefreshCart = (opts = {}) => refreshCartUI({ allowClear: true, ...opts });


})(); // <— o singură închidere IIFE, nimic după!
*/

// [stub] Dublura de recalc pentru “Adaugă toate” a fost eliminată.
// Ne bazăm pe window.NPX_recalcBulk definit mai sus.




/* NPX — Scroll la "Tabel referinte" (cu corecție după sticky header) */
(function () {
  if (window.__npx_refs_fix) return; window.__npx_refs_fix = true;

  function stickyOffset() {
    let h = 0;
    const sel = [
      'header', '.m-header', '.header', '.m-header-sticky', '.header-sticky',
      '.m-announcement-bar', '.announcement-bar',
      '.m-main-nav', '.main-nav', '.sf-mega-menu', '.m-megamenu',
      '.collection-menu', '.m-header__bottom'
    ].join(',');
    document.querySelectorAll(sel).forEach(el => {
      const cs = getComputedStyle(el);
      const r  = el.getBoundingClientRect();
      const isTop = r.top <= 0 && r.bottom > 0;
      if ((cs.position === 'fixed' || cs.position === 'sticky') && isTop) {
        h += r.height || el.offsetHeight || 0;
      }
    });
    // fallback + mic gap
    return (h || (window.innerWidth < 992 ? 170 : 140)) + 12;
  }

  function smartGotoRefs(e){
    if (e && e.preventDefault) e.preventDefault();
    const a = document.getElementById('refs-anchor');
    if (!a) return;

    // 1) scroll inițial
    const target = a.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });

    // 2) corecții după ce header-ul/viewport-ul se stabilizează
    const fix = () => {
      const diff = a.getBoundingClientRect().top - stickyOffset();
      if (Math.abs(diff) > 2) window.scrollBy({ top: diff, behavior: 'auto' });
    };
    setTimeout(fix, 120);
    setTimeout(fix, 300);
  }

  // expune funcția pentru butoanele „Alege varianta și adaugă”
  window.gotoRefs = smartGotoRefs;

  // Linkuri <a href="#refs-anchor">
  document.addEventListener('click', function (e) {
    const t = e.target.closest('a[href="#refs-anchor"]');
    if (!t) return;
    smartGotoRefs(e);
  }, true);
})();



/* NPX — leagă butonul "Alege varianta si adauga" de scroll la #refs-anchor */
/*
(function () {
  function normalize(s){
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // fără diacritice
      .replace(/\s+/g,'')
      .trim();
  }
  function isTarget(el){
    const t = normalize(el.textContent || el.value || '');
    // prinde și variații ("alege varianta", "adaugă", etc.)
    return t.includes('alegevariantasiadauga') || (t.includes('alegevarianta') && t.includes('adauga'));
  }
  function bind(el){
    if (!el || el.__npx_bound_refs) return;
    el.__npx_bound_refs = true;
    el.addEventListener('click', function(ev){
      // oprim default (dacă e <a>) și facem scrollul nostru corect cu offset
      ev.preventDefault();
      if (typeof window.gotoRefs === 'function') window.gotoRefs();
    }, { passive:false });
    // dacă e <a>, setăm și href ca fallback
    if (el.tagName === 'A') el.setAttribute('href', '#refs-anchor');
  }
  function scan(){
    document.querySelectorAll('a,button').forEach(el => { if (isTarget(el)) bind(el); });
  }
  document.addEventListener('DOMContentLoaded', scan);
  // pentru cazurile când tema montează butonul mai târziu
  new MutationObserver(scan).observe(document.documentElement, { childList:true, subtree:true });
})();
*/
/* NPX — TEST: întârziem 1s scroll-ul nostru ca să vedem dacă tema scrolează singură */
(function () {
  if (window.__npx_scroll_test) return; window.__npx_scroll_test = true;

  var WAIT = window.matchMedia('(max-width: 990px)').matches ? 800 : 350;


  function stickyOffset() {
    var h = 0;
    var sel = [
      'header', '.m-header', '.header', '.m-header-sticky', '.header-sticky',
      '.m-announcement-bar', '.announcement-bar',
      '.m-main-nav', '.main-nav', '.sf-mega-menu', '.m-megamenu',
      '.collection-menu', '.m-header__bottom'
    ].join(',');
    document.querySelectorAll(sel).forEach(function (el) {
      var cs = getComputedStyle(el);
      var r  = el.getBoundingClientRect();
      var isTop = r.top <= 0 && r.bottom > 0;
      if ((cs.position === 'fixed' || cs.position === 'sticky') && isTop) {
        h += r.height || el.offsetHeight || 0;
      }
    });
    return (h || (window.innerWidth < 992 ? 170 : 140)) + 24; // fallback + mic gap
  }

  function smartGotoRefsNow() {
    var a = document.getElementById('refs-anchor');
    if (!a) return;
    var top = a.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

    // corecție fină după ce se stabilizează sticky
    setTimeout(function () {
      var diff = a.getBoundingClientRect().top - stickyOffset();
      if (Math.abs(diff) > 2) window.scrollBy({ top: diff, behavior: 'auto' });
    }, 220);
  }

  function onTriggerClick(e) {
    // IMPORTANT: NU dăm preventDefault — vrem să vedem dacă tema scrolează singură
    var startY = window.pageYOffset;
    var maxDelta = 0;
    var off0 = stickyOffset();

    function onScroll() {
      var d = Math.abs(window.pageYOffset - startY);
      if (d > maxDelta) maxDelta = d;
      startY = window.pageYOffset;
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    console.log('[NPX test] Pornit. Aștept', WAIT, 'ms să văd dacă tema scrolează singură...');
    setTimeout(function () {
      window.removeEventListener('scroll', onScroll);
      var off1 = stickyOffset();
      console.log('[NPX test] Delta maximă detectată în', WAIT, 'ms:', maxDelta, 'px');
      console.log('[NPX test] Sticky offset Δ =', (off1 - off0), 'px (dacă variază, header-ul schimbă înălțimea după click).');
      console.log('[NPX test] Acum fac scroll-ul nostru controlat.');
      smartGotoRefsNow();
    }, WAIT);
  }

  function normalize(s){
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/\s+/g,'').trim();
  }
  function isTarget(el){
    var t = normalize(el.textContent || el.value || '');
    return t.includes('alegevariantasiadauga') || (t.includes('alegevarianta') && t.includes('adauga'));
  }
  function bind(el){
    if (el.__npx_bound_scrolltest) return;
    el.__npx_bound_scrolltest = true;
    el.addEventListener('click', onTriggerClick, { passive: true }); // fără preventDefault
  }
  function scan(){
    document.querySelectorAll('a,button').forEach(function(el){ if (isTarget(el)) bind(el); });
  }
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList:true, subtree:true });

  // și pentru orice <a href="#refs-anchor"> existent în pagină
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href="#refs-anchor"]');
    if (!t) return;
    onTriggerClick(e); // NU prevenim default-ul
  }, true);
})();

/* NPX — Guard cantități: admite doar cifre; “0” rămâne 0; clamp doar pentru >0 */
(function(){
  if (window.__npx_qty_guard) return; window.__npx_qty_guard = true;

  const SEL = '.article-quantity-input';
  const DEF_MIN = 1, DEF_MAX = 999999;
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

function normalizeEl(inp){
  if (!inp) return;

  let raw = String(inp.value || '').replace(/[^\d]/g, '');
  // 0 sau gol → ținem "0"
  if (raw === '' || raw === '0') { inp.value = '0'; return; }

  // remaining real (inv - în coș) / max
  let remain = parseInt(
    inp.dataset.remaining || inp.getAttribute('data-remaining') ||
    inp.dataset.max       || inp.getAttribute('max') ||
    inp.dataset.inv       || inp.getAttribute('data-inv') || '0',
    10
  );
  if (!Number.isFinite(remain)) remain = 0;

  // dacă nu mai e nimic de adăugat, dar s-a tastat >0 → mesaj + 0
  if (remain <= 0) {
    inp.value = '0';
    if (window.NPX_limitMsg) window.NPX_limitMsg(0, { inputEl: inp });
    return;
  }

  let v0 = parseInt(raw.replace(/^0+(?=\d)/,''), 10);
  if (!Number.isFinite(v0) || v0 <= 0) { inp.value = '0'; return; }

  const min  = +inp.dataset.min  || +inp.min || 1;
  const max  = Math.max(0, +inp.dataset.max || +inp.max || remain); // clamp la remaining
  const step = +inp.dataset.step || +inp.step || 1;

  let v = Math.max(min, Math.min(max, v0));
  if (step > 1) v = Math.min(max, Math.ceil(v/step)*step);
  v = Math.max(min, Math.min(max, v));

  // dacă am tăiat la MAX pentru că userul a depășit → arată mesaj
  if (v0 > max && typeof window.NPX_limitMsg === 'function') {
    window.NPX_limitMsg(max, { inputEl: inp });
  }

  inp.value = String(v);
}


// blochează non-cifre și ÎNTREAGA tastare când remaining=0 (dar lăsăm navigarea)
document.addEventListener('keydown', function(e){
  const inp = e.target.closest(SEL);
  if (!inp) return;

  const allow = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End','Enter'];
  if (allow.includes(e.key)) return;

  // === Nou: dacă remaining=0 → nu permitem cifre & anunțăm
  const remain = parseInt(
    inp.dataset.remaining || inp.getAttribute('data-remaining') ||
    inp.dataset.max       || inp.getAttribute('max') || '0',
    10
  ) || 0;

  if (remain <= 0) {
    if (/^\d$/.test(e.key)) {
      e.preventDefault();
      if (typeof window.NPX_limitMsg === 'function') window.NPX_limitMsg(0);
    }
    return;
  }

  if (!/^\d$/.test(e.key)) e.preventDefault();
}, true);


  // expune pentru plus/minus
  window.NPX_normalizeQtyById = function(id){
    const el = document.getElementById(id);
    if (!el) return;

    // normalizează valoarea
    normalizeEl(el);

    // anunță restul handlerelor
    try { el.dispatchEvent(new Event('input', { bubbles:true })); } catch(_){}

    // activează/dezactivează butoanele de coș (desktop + mobil) pentru varianta curentă
    const form = el.closest('form');
    const vId  = form?.querySelector('input[name="id"]')?.value;
    if (vId){
      const n = parseInt(String(el.value||'').replace(/[^\d]/g,''),10) || 0;
      const d = document.getElementById('add-btn'    + vId);
      const m = document.getElementById('mb-add-btn' + vId);
      if (d) d.disabled = !(n > 0);
      if (m) m.disabled = !(n > 0);
    }

    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
  };


  // tastare + paste
  document.addEventListener('input', function(e){
    const inp = e.target.closest(SEL);
    if (inp) normalizeEl(inp);
  }, true);

  // blochează non-cifre (lăsăm navigarea)
  document.addEventListener('keydown', function(e){
    const inp = e.target.closest(SEL);
    if (!inp) return;
    const allow = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End','Enter'];
    if (allow.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  }, true);

  // la blur, clamp final
  document.addEventListener('blur', function(e){
    const inp = e.target.closest(SEL);
    if (inp) normalizeEl(inp);
  }, true);

  // UX: selectează tot la focus
  document.addEventListener('focus', e => {
    if (e.target.matches(SEL)) setTimeout(()=>e.target.select(), 0);
  }, true);
    // init: pornește cu "0" pentru toate câmpurile goale
  window.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll(SEL).forEach(function(inp){
      if (String(inp.value || '').trim() === '') { inp.value = '0'; }
    });
  }, { once:true });

})();

/* NPX — Tabel: setează max = (stoc - cât ai deja în coș) + dezactivează butoanele când e 0 */
(function(){
  if (window.__npx_vtable_caps) return; window.__npx_vtable_caps = true;

  const note = (m)=>{ try{ window.NPX_note && window.NPX_note(m); }catch(_){ } };

  function collectInputs(){
    return Array.from(document.querySelectorAll('.variant_detail .article-quantity-input'));
  }

  async function getCart(){
    try{
      const r = await fetch('/cart.js', { cache:'no-store', headers:{'Accept':'application/json'} });
      return await r.json();
    }catch(_){ return { items:[] }; }
  }

function applyCaps(cart){
  const inCart = new Map();
  (cart.items||[]).forEach(it=>{
    inCart.set(String(it.variant_id), (inCart.get(String(it.variant_id))||0) + (it.quantity||0));
  });

  collectInputs().forEach(inp=>{
    const form = inp.closest('form');
    const vid  = form?.querySelector('input[name="id"]')?.value;
    if (!vid) return;

    const inv    = parseInt(inp.dataset.inv || inp.getAttribute('data-inv') || '0',10) || 0;
    const have   = inCart.get(String(vid)) || 0;
    const remain = Math.max(0, inv - have);

    // expune remaining pentru toate validările
    inp.dataset.max = String(remain);
    inp.setAttribute('data-max', String(remain));
    inp.setAttribute('data-remaining', String(remain));
    inp.setAttribute('data-mode','add');

    // dacă valoarea depășește noul cap → taie + mesaj unic
    const cur = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10) || 0;
   if (cur > remain){
  inp.value = remain ? String(remain) : '0'; // ← ținem '0', nu '' (ca să nu redevină 1)
  try { inp.dispatchEvent(new Event('input', { bubbles:true })); } catch(_){}
  if (cur > 0 && window.NPX_limitMsg) window.NPX_limitMsg(remain);
}


    // butoanele Add to cart: activ la >0, inactiv la 0 sau când remain=0
const d = document.getElementById('add-btn' + vid);
const m = document.getElementById('mb-add-btn' + vid);

// ✅ citește explicit din inputul DESKTOP și din inputul MOBIL
const dsInp = document.getElementById('q' + vid);
const curD  = parseInt(String(dsInp?.value || '').replace(/[^\d]/g, ''), 10) || 0;

const mbInp = document.getElementById('mb-q' + vid);
const curM  = parseInt(String(mbInp?.value || '').replace(/[^\d]/g, ''), 10) || 0;

if (d) d.disabled = (remain <= 0) || !(curD > 0);
if (m) m.disabled = (remain <= 0) || !(curM > 0);

  });
}



  async function run(){ const cart = await getCart(); applyCaps(cart); }
  document.addEventListener('DOMContentLoaded', run, { once:true });
  document.addEventListener('cart:updated', run);
  document.addEventListener('cart:change', run);
})();
(function () {
  if (window.__npx_click_guard_v1) return; window.__npx_click_guard_v1 = true;
  function q(v){ v = String(v||'').replace(/^0+(?=\d)/,''); const n = parseInt(v,10); return Number.isInteger(n)?n:NaN; }
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.variant-tabel form .set-addcard-btn, .variant-tabel form button[type="submit"]');
    if (!btn) return;
    const form = btn.closest('form');
    const inp  = form?.querySelector('input.article-quantity-input');
    const n    = q(inp?.value);
    if (!(Number.isInteger(n) && n > 0)) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
      btn.disabled = true; inp?.focus();
    }
  }, true);
})();

/* NPX — Mesaje pe /cart (plus/minus + input manual) */
(function(){
  if (window.__npx_cart_msgs_v1) return; window.__npx_cart_msgs_v1 = true;

  var SEL = 'form[action="/cart"] input[name^="updates"], .m-cart-drawer input[name^="updates"], .m-cart input[name^="updates"], .m-cart__panel input[name^="updates"]';

  function clampAndToast(inp){
    var max = parseInt(inp.getAttribute('max') || inp.dataset.max || '999999',10) || 999999;
    var min = parseInt(inp.getAttribute('min') || inp.dataset.min || '1',10) || 1;
    var val0 = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10);
    var val = Number.isFinite(val0) ? val0 : min;

    var hitMax = false, hitMin = false;
    if (val > max) { val = max; hitMax = true; }
    if (val < min) { val = min; hitMin = true; }

    if (String(val) !== String(inp.value)) {
      inp.value = String(val);
      try { inp.dispatchEvent(new Event('change', { bubbles:true })); } catch(_){}
    }
    if (hitMax && window.NPX_limitMsg) NPX_limitMsg(max);
    if (hitMin && window.NPX_note) NPX_note('Cantitatea minimă este '+min+'.', {type:'info'});
  }

  function bind(){
    document.querySelectorAll(SEL).forEach(function(inp){
      if (inp.__npxBound) return; inp.__npxBound = true;
      ['input','change','blur'].forEach(function(ev){ inp.addEventListener(ev, function(){ clampAndToast(inp); }); });
      clampAndToast(inp);
    });
  }

  function plusMinusHint(e){
    var btn = e.target.closest('button[name="plus"],button[name="minus"]'); if (!btn) return;
    var wrap = btn.closest('.m-quantity, .quantity, .m-cart__qty, .cart-item-qty, .m-quantity-input');
    var inp  = wrap && wrap.querySelector(SEL); if (!inp) return;

    var max = parseInt(inp.getAttribute('max') || inp.dataset.max || '999999',10) || 999999;
    var min = parseInt(inp.getAttribute('min') || inp.dataset.min || '1',10) || 1;
    var val = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10) || 0;

    if (btn.name === 'plus' && val >= max) { e.preventDefault(); if (window.NPX_limitMsg) NPX_limitMsg(max); }
    if (btn.name === 'minus' && val <= min) { e.preventDefault(); if (window.NPX_note) NPX_note('Cantitatea minimă este '+min+'.', {type:'info'}); }
  }

  document.addEventListener('DOMContentLoaded', bind, { once:true });
  new MutationObserver(bind).observe(document.documentElement, { childList:true, subtree:true });
  document.addEventListener('click', plusMinusHint, true);
})();

/* === FIX mob: + trebuie să arate mesaj și la cap (nu doar la cap=0) === */
window.mb_handlePlus = function (input_id) {
  const input = document.getElementById(input_id);
  if (!input) return;

  let remain = parseInt(
    input.dataset.remaining || input.getAttribute('data-remaining') ||
    input.dataset.max       || input.getAttribute('max') ||
    input.dataset.inv       || input.getAttribute('data-inv') || '0',
    10
  );
  if (!Number.isFinite(remain) || remain < 0) remain = 0;

  const variantId = (input_id.match(/\d+$/) || [null])[0];

  // nimic de adăugat
  if (remain <= 0) {
    if (window.NPX_limitMsg) window.NPX_limitMsg(0, { inputEl: input });
    input.value = '0';
    if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
    if (typeof mb_setBtn === 'function') mb_setBtn(variantId);
    const state = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
    if (state) mbHighlight(state, 0);
    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
    return;
  }

  // deja la cap → arată mesaj, nu mai crește
  const raw = (input.value || '').replace(/^0+(?=\d)/, '');
  const n0  = parseInt(raw, 10) || 0;
  if (n0 >= remain) {
    if (window.NPX_limitMsg) window.NPX_limitMsg(remain, { inputEl: input });
    input.value = String(remain);
    if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
    if (typeof mb_setBtn === 'function') mb_setBtn(variantId);
    const state = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
    if (state) mbHighlight(state, remain);
    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
    return;
  }

  // creștere normală, dar nu peste remain
  const next = Math.min((n0 < 1 ? 1 : n0 + 1), remain);
  input.value = String(next);
  if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
  if (typeof mb_setBtn === 'function') mb_setBtn(variantId);
  const state = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
  if (state) mbHighlight(state, next);
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();
};

/* ======= NPX — Total în modalul mobil (lângă coș) ======= */
(function(){
  if (window.__npx_mb_total) return; window.__npx_mb_total = true;

  function parsePriceNumber(txt){
    const s = String(txt || '').replace(/[^\d.,-]/g, '');
    if (!s) return NaN;
    const lastDot  = s.lastIndexOf('.');
    const lastComm = s.lastIndexOf(',');
    const lastSep  = Math.max(lastDot, lastComm);
    let num = s;
    if (lastSep >= 0) {
      const intPart = s.slice(0, lastSep).replace(/[.,]/g, '');
      const decPart = s.slice(lastSep + 1);
      num = intPart + '.' + decPart;
    } else {
      num = s.replace(/[^\d-]/g, '');
    }
    const v = parseFloat(num);
    return Number.isFinite(v) ? v : NaN;
  }
  const currencyFromText = (txt) => String(txt || '').replace(/[0-9\s.,]/g, '').trim() || 'lei';
  const fmt = (n, cur) => (n).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}) + (cur?` ${cur}`:'');

  // Construiește treptele din butoane (min/max + PREȚ), preferând data-atributele
  function getTiers(modal){
    const cont = modal.querySelector('.mb-discount-btn-container');
    if (!cont) return [];
    const btns = Array.from(cont.querySelectorAll('button'));
    const thresholds = btns.map(b => {
      const raw = (b.querySelector(':scope > span')?.textContent || b.textContent || '').trim();
      const m = raw.match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    });
    return btns.map((b, i) => {
      // citește prețul din data-price; fallback la text
      let price = parseFloat(b.getAttribute('data-price'));
      let cur   = b.getAttribute('data-currency') || 'lei';
      if (!Number.isFinite(price)) {
        const txt = b.querySelector('div span')?.textContent
                 || b.querySelector('div')?.textContent
                 || b.textContent || '';
        price = parsePriceNumber(txt);
        cur   = currencyFromText(txt);
      }
      return {
        btn: b,
        min: i === 0 ? 1 : thresholds[i],
        max: i === thresholds.length - 1 ? Infinity : (thresholds[i + 1] - 1),
        price, cur
      };
    });
  }

  function unitPriceForQty(tiers, q){
    if (!tiers.length) return { price: NaN, cur: 'lei' };
    let chosen = tiers[0];
    for (let i = 0; i < tiers.length; i++){
      const t = tiers[i];
      if (q >= t.min && q <= t.max) { chosen = t; break; }
      if (q >= t.min) chosen = t;
    }
    return { price: chosen.price, cur: chosen.cur };
  }

  // Expus global — chemat la deschiderea modalului și pe input
  window.NPX_updateMobileTotal = function(variantId){
    const modal = document.getElementById('cart-content' + variantId);
    const input = document.getElementById('mb-q' + variantId);
    const wrap  = document.getElementById('mb-total-wrap' + variantId);
    const out   = document.getElementById('mb-total' + variantId);
    if (!modal || !input || !wrap || !out) return;

    const q = parseInt(String(input.value || '').replace(/[^\d]/g, ''), 10) || 0;
    if (q <= 0) { wrap.classList.remove('is-visible'); wrap.hidden = true; return; }

    const tiers = getTiers(modal);
    const { price, cur } = unitPriceForQty(tiers, q);
    if (!Number.isFinite(price) || price <= 0) { wrap.classList.remove('is-visible'); wrap.hidden = true; return; }

    out.textContent = fmt(price * q, cur); // ← PREȚ * CANTITATE
    wrap.hidden = false;
    wrap.classList.add('is-visible');
  };

  // Update la tastare în inputul mobil
  document.addEventListener('input', function(e){
    const inp = e.target.closest('.sticky-add-modal-content .article-quantity-input[id^="mb-q"]');
    if (!inp) return;
    const vid = (inp.id.match(/\d+$/) || [null])[0];
    if (vid) window.NPX_updateMobileTotal(vid);
  }, true);

  // Update după click pe o treaptă de preț
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.sticky-add-modal-content .mb-discount-btn-container button');
    if (!btn) return;
    const modal = btn.closest('.sticky-add-modal-content');
    const vid = (modal?.id.match(/\d+$/) || [null])[0];
    if (!vid) return;
    setTimeout(() => window.NPX_updateMobileTotal(vid), 0);
  }, true);
})();


// === NPX PATCH — butoanele de preț setează pragul SAU (inventar - coș), cu mesaj ===
window.handleBulkQntyAdder = function(input_id, want){
  const inp = document.getElementById(input_id);
  if (!inp) return;

  // remaining prioritar: data-remaining → data-max/max → data-inv
  let remain = parseInt(
    inp.dataset.remaining || inp.getAttribute('data-remaining') ||
    inp.dataset.max       || inp.getAttribute('max') ||
    inp.dataset.inv       || inp.getAttribute('data-inv') || '0', 10
  );
  if (!Number.isFinite(remain) || remain < 0) remain = 0;

  const step     = parseInt(inp.dataset.step || inp.step || '1', 10) || 1;
  const desired  = parseInt(String(want), 10) || 1;
  const variantId= (input_id.match(/\d+$/) || [null])[0];

  // nimic disponibil → 0 + mesaj
  if (remain <= 0) {
    inp.value = '0';
    if (window.NPX_limitMsg) window.NPX_limitMsg(0, { inputEl: inp });
    if (window.NPX_normalizeQtyById) window.NPX_normalizeQtyById(input_id);
    if (typeof mb_setBtn === 'function' && variantId) mb_setBtn(variantId);
    const st = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
    if (st) mbHighlight(st, 0);
    if (window.NPX_updateMobileTotal && variantId) NPX_updateMobileTotal(variantId);
    if (window.NPX_recalcBulk) window.NPX_recalcBulk();
    return;
  }

  // cantitatea finală: min(prag, remain), respectând step (rotunjire în jos)
  let q = Math.min(desired, remain);
  if (step > 1) q = Math.floor(q / step) * step;
  q = Math.max(1, Math.min(q, remain));

  // setează în input + normalizează (activează butonul, declanșează hook-urile)
  inp.value = String(q);
  if (window.NPX_normalizeQtyById) {
    window.NPX_normalizeQtyById(input_id);
  } else {
    try { inp.dispatchEvent(new Event('input', { bubbles:true })); } catch(_){}
  }

  // ținem capul sincronizat în data-max pentru alte gardieni
  inp.dataset.max = String(remain);
  inp.setAttribute('data-max', String(remain));

  // dacă am plafonat pragul → mesajul galben inline
  if (desired > remain && window.NPX_limitMsg) {
    window.NPX_limitMsg(remain, { inputEl: inp });
  }

  // UI: highlight tier, buton add, total
  if (typeof mb_setBtn === 'function' && variantId) mb_setBtn(variantId);
  const st = typeof mbInitModal === 'function' ? mbInitModal(variantId) : null;
  if (st) mbHighlight(st, q);
  if (window.NPX_updateMobileTotal && variantId) NPX_updateMobileTotal(variantId);
  if (window.NPX_recalcBulk) window.NPX_recalcBulk();
};

/* ======= NPX — Total curent pe DESKTOP (qty × preț de treaptă) ======= */
(function(){
  if (window.__npx_desk_total_v1) return; window.__npx_desk_total_v1 = true;

  /* mic stil injectat, dacă nu ai în CSS */
  (function ensureStyle(){
    if (document.getElementById('npx-desk-total-style')) return;
    var s = document.createElement('style');
    s.id = 'npx-desk-total-style';
    s.textContent =
      '.npx-desk-total{display:none;gap:8px;align-items:center;justify-content:flex-end;margin-top:8px;}' +
      '.npx-desk-total.is-visible{display:flex}' +
      '.npx-desk-total .lab{opacity:.7;font-weight:600}' +
      '.npx-desk-total .val{font-weight:700}';
    (document.head||document.documentElement).appendChild(s);
  })();

  function parsePriceNumber(txt){
    const s = String(txt||'').replace(/[^\d.,-]/g,'');
    if (!s) return NaN;
    const lastDot  = s.lastIndexOf('.');
    const lastComm = s.lastIndexOf(',');
    const lastSep  = Math.max(lastDot, lastComm);
    let num = s;
    if (lastSep >= 0){
      const intPart = s.slice(0,lastSep).replace(/[.,]/g,'');
      const decPart = s.slice(lastSep+1);
      num = intPart + '.' + decPart;
    } else {
      num = s.replace(/[^\d-]/g,'');
    }
    const v = parseFloat(num);
    return Number.isFinite(v) ? v : NaN;
  }
  const fmt = (n) => n.toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' lei';

  function ensureOut(vId){
    let wrap = document.getElementById('dsk-total-wrap'+vId);
    if (wrap) return wrap;

    // plasăm în containerul cu butoanele de cantitate
    const parent = document.querySelector('#vtable-d-'+vId+' .align-quantity-btn')
                || document.querySelector('.variant_detail input#q'+vId)?.closest('.align-quantity-btn');
    if (!parent) return null;

    wrap = document.createElement('div');
    wrap.id = 'dsk-total-wrap'+vId;
    wrap.className = 'npx-desk-total';
    wrap.innerHTML = '<span class="lab">Total</span><span class="val" id="dsk-total'+vId+'"></span>';
    parent.appendChild(wrap);
    return wrap;
  }

  function getTiers(vId){
    const nodes = Array.from(document.querySelectorAll('.priceCl'+vId+'[data-qty-interval]'))
      .filter(td => td.getAttribute('data-qty-interval') !== 'null')
      .map(td => ({
        ceil: parseInt(td.getAttribute('data-qty-interval'),10),
        price: parsePriceNumber(td.querySelector('.rjnxt-price')?.textContent || td.textContent || '')
      }))
      .filter(t => Number.isFinite(t.ceil));
    nodes.sort((a,b)=>a.ceil-b.ceil);

    // construim intervalele [min..max] pentru selecție
    return nodes.map((t,i,arr)=>({
      min: i===0 ? 1 : t.ceil,
      max: i===arr.length-1 ? Infinity : (arr[i+1].ceil - 1),
      price: t.price
    }));
  }

  function unitPriceForQty(tiers, q){
    if (!tiers.length) return NaN;
    let up = tiers[0].price;
    for (let i=0;i<tiers.length;i++){
      const t = tiers[i];
      if (q >= t.min && q <= t.max){ up = t.price; break; }
      if (q >= t.min) up = t.price;
    }
    return up;
  }

  // expunem pentru a-l chema din alte handler-e, dacă vrei
  window.NPX_updateDesktopTotal = function(vId){
    const inp = document.getElementById('q'+vId);
    if (!inp) return;

    const q = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10) || 0;
    const outWrap = ensureOut(vId);
    if (!outWrap) return;

    if (q <= 0){
      outWrap.classList.remove('is-visible');
      outWrap.style.display = 'none';
      return;
    }

    const tiers = getTiers(vId);
    const unit  = unitPriceForQty(tiers, q);
    if (!Number.isFinite(unit) || unit <= 0){
      outWrap.classList.remove('is-visible');
      outWrap.style.display = 'none';
      return;
    }

    const out = document.getElementById('dsk-total'+vId);
    if (out) out.textContent = fmt(unit * q);
    outWrap.style.display = '';
    outWrap.classList.add('is-visible');
  };

  /* ——— hook-uri: orice schimbare de input actualizează totalul ——— */
  document.addEventListener('input', function(e){
    const inp = e.target.closest('.variant_detail .article-quantity-input[id^="q"]');
    if (!inp) return;
    const vId = (inp.id.match(/\d+$/) || [null])[0];
    if (vId) window.NPX_updateDesktopTotal(vId);
  }, true);

  // inițializare la încărcare (utile dacă ai restore din sessionStorage)
  window.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.variant_detail input.article-quantity-input[id^="q"]').forEach(inp=>{
      const vId = (inp.id.match(/\d+$/) || [null])[0];
      if (vId) window.NPX_updateDesktopTotal(vId);
    });
  }, { once:true });

})();

/* ======= NPX — Total TABEL (sumă toate rândurile) ======= */
(function(){
  if (window.__npx_table_total_v1) return; window.__npx_table_total_v1 = true;

  // ——— mici utilitare locale ———
  function parsePriceNumber(txt){
    const s = String(txt||'').replace(/[^\d.,-]/g,'');
    if (!s) return NaN;
    const lastDot  = s.lastIndexOf('.'), lastCom = s.lastIndexOf(',');
    const lastSep  = Math.max(lastDot, lastCom);
    let num = s;
    if (lastSep >= 0){
      const intPart = s.slice(0,lastSep).replace(/[.,]/g,'');
      const decPart = s.slice(lastSep+1);
      num = intPart + '.' + decPart;
    } else {
      num = s.replace(/[^\d-]/g,'');
    }
    const v = parseFloat(num);
    return Number.isFinite(v) ? v : NaN;
  }
  const fmt = (n) => n.toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' lei';

  function getTiers(vId){
    const cells = Array.from(document.querySelectorAll('.priceCl'+vId+'[data-qty-interval]'))
      .filter(td => td.getAttribute('data-qty-interval') !== 'null')
      .map(td => ({
        ceil: parseInt(td.getAttribute('data-qty-interval'),10),
        price: parsePriceNumber(td.querySelector('.rjnxt-price')?.textContent || td.textContent || '')
      }))
      .filter(t => Number.isFinite(t.ceil));
    cells.sort((a,b)=>a.ceil-b.ceil);
    return cells.map((t,i,a)=>({ min: i? t.ceil : 1, max: i===a.length-1? Infinity : (a[i+1].ceil-1), price:t.price }));
  }
  function unitForQty(vId, q){
    const tiers = getTiers(vId);
    if (!tiers.length) return NaN;
    let up = tiers[0].price;
    for (let i=0;i<tiers.length;i++){
      const t = tiers[i];
      if (q >= t.min && q <= t.max){ up = t.price; break; }
      if (q >= t.min) up = t.price;
    }
    return up;
  }

  // creează bara de total sub tabel
  function ensureBar(){
    let bar = document.getElementById('npx-table-total');
    if (bar) return bar;
    const host = document.querySelector('.set-table-x') || document.querySelector('.veriations-table');
    if (!host) return null;
    bar = document.createElement('div');
    bar.id = 'npx-table-total';
    bar.className = 'npx-table-total';
    bar.innerHTML =
      '<div class="inner"><span class="lab">Total tabel</span><span class="val">0,00 lei</span></div>';
    host.appendChild(bar);
    return bar;
  }

  function recalc(){
    const bar = ensureBar(); if (!bar) return;
    let sum = 0;

    document.querySelectorAll('.variant_detail input.article-quantity-input[id^="q"]').forEach(inp=>{
      const vId = (inp.id.match(/\d+$/) || [null])[0];
      const q = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10) || 0;
      if (!vId || q <= 0) return;
      const up = unitForQty(vId, q);
      if (Number.isFinite(up) && up > 0) sum += up * q;
    });

    const out = bar.querySelector('.val');
    if (out) out.textContent = sum > 0 ? fmt(sum) : '0,00 lei';
    bar.classList.toggle('is-visible', sum > 0);
  }

  // expune dacă vrei să îl chemi manual din alte handler-e
  window.NPX_recalcTableTotal = recalc;

  // hook: orice input în câmpurile de cantitate
  document.addEventListener('input', function(e){
    if (!e.target.closest('.variant_detail .article-quantity-input')) return;
    recalc();
  }, true);

  // init
  window.addEventListener('DOMContentLoaded', recalc, { once:true });

  // dacă ai definit NPX_updateDesktopTotal, îl „decorăm” să refacă și totalul de tabel
  if (typeof window.NPX_updateDesktopTotal === 'function' && !window.NPX_updateDesktopTotal.__npxDecorated){
    const orig = window.NPX_updateDesktopTotal;
  window.NPX_updateDesktopTotal = function(vId){
    const inp = document.getElementById('q'+vId);
    if (!inp) return;

    // asigură existența containerului (nu îl arătăm/ascundem, îl lăsăm mereu în layout)
    const outWrap = (function ensureOut(){
      let wrap = document.getElementById('dsk-total-wrap'+vId);
      if (wrap) return wrap;
      const parent = document.querySelector('#vtable-d-'+vId+' .align-quantity-btn')
               || document.querySelector('.variant_detail input#q'+vId)?.closest('.align-quantity-btn');
      if (!parent) return null;
      wrap = document.createElement('div');
      wrap.id = 'dsk-total-wrap'+vId;
      wrap.className = 'npx-desk-total'; // <-- important: fără toggle de display
      wrap.innerHTML = '<span class="lab">Total</span><span class="val" id="dsk-total'+vId+'"></span>';
      parent.appendChild(wrap);
      return wrap;
    })();
    if (!outWrap) return;

    const q = parseInt(String(inp.value||'').replace(/[^\d]/g,''),10) || 0;
    const out = document.getElementById('dsk-total'+vId);

    // helperi existenți în IIFE
    function parsePriceNumber(txt){
      const s = String(txt||'').replace(/[^\d.,-]/g,'');
      if (!s) return NaN;
      const lastDot  = s.lastIndexOf('.');
      const lastComm = s.lastIndexOf(',');
      const lastSep  = Math.max(lastDot, lastComm);
      let num = s;
      if (lastSep >= 0){
        const intPart = s.slice(0,lastSep).replace(/[.,]/g,'');
        const decPart = s.slice(lastSep+1);
        num = intPart + '.' + decPart;
      } else {
        num = s.replace(/[^\d-]/g,'');
      }
      const v = parseFloat(num);
      return Number.isFinite(v) ? v : NaN;
    }
    const fmt = (n) => n.toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' lei';

    function getTiers(){
      const cells = Array.from(document.querySelectorAll('.priceCl'+vId+'[data-qty-interval]'))
        .filter(td => td.getAttribute('data-qty-interval') !== 'null')
        .map(td => ({
          ceil: parseInt(td.getAttribute('data-qty-interval'),10),
          price: parsePriceNumber(td.querySelector('.rjnxt-price')?.textContent || td.textContent || '')
        }))
        .filter(t => Number.isFinite(t.ceil))
        .sort((a,b)=>a.ceil-b.ceil);

      return cells.map((t,i,a)=>({
        min: i===0 ? 1 : t.ceil,
        max: i===a.length-1 ? Infinity : (a[i+1].ceil - 1),
        price: t.price
      }));
    }

    function unitPriceForQty(tiers, q){
      if (!tiers.length) return NaN;
      let up = tiers[0].price;
      for (let i=0;i<tiers.length;i++){
        const t = tiers[i];
        if (q >= t.min && q <= t.max){ up = t.price; break; }
        if (q >= t.min) up = t.price;
      }
      return up;
    }

    // === LOGICĂ DE AFIȘARE FĂRĂ "SĂRIT" ===
    if (q <= 0){
      if (out) out.textContent = '';         // nu afișăm cifre la 0
      outWrap.classList.add('is-zero');      // CSS ascunde cifrele, dar păstrează lățimea
      return;
    }

    const tiers = getTiers();
    const unit  = unitPriceForQty(tiers, q);

    if (!Number.isFinite(unit) || unit <= 0){
      if (out) out.textContent = '';
      outWrap.classList.add('is-zero');
      return;
    }

    if (out) out.textContent = fmt(unit * q);
    outWrap.classList.remove('is-zero');
  };

    window.NPX_updateDesktopTotal.__npxDecorated = true;
  }
})();


/* NPX — “Total tabel” sub tabel (dreapta), butonul bulk mai jos și centrat */
(function(){
  function placeTableTotal(){
    var total = document.getElementById('npx-table-total');
    if (!total) return;

    // 1) Încearcă să-l pună chiar DUPĂ tabelul de variante
    var table = document.querySelector('.set-table-x .set-data-table');
    if (table && table.parentNode) {
      if (table.nextElementSibling !== total) {
        table.parentNode.insertBefore(total, table.nextElementSibling);
      }
      return;
    }

    // 2) Fallback: înaintea butonului "Adaugă toate în coș"
    var bulk = document.querySelector('.bulk-add-cart-btn');
    if (bulk && bulk.parentNode && total.nextElementSibling !== bulk) {
      bulk.parentNode.insertBefore(total, bulk);
    }
  }

  // Rulează la load + la re-renderări de temă
  window.addEventListener('DOMContentLoaded', placeTableTotal, { once:true });
  new MutationObserver(placeTableTotal).observe(document.documentElement, { childList:true, subtree:true });

  // expune dacă vrei să-l chemi manual
  window.NPX_placeTableTotal = placeTableTotal;
})();





  window.checkQuantity      = checkQuantity;
  window.handlePlus         = handlePlus;
  window.handleMinus        = handleMinus;
  window.AddBulkQuantity    = AddBulkQuantity;

  window.handleMobileCart   = handleMobileCart;
  window.closeModal         = closeModal;
  window.mb_handleMinus     = mb_handleMinus;

  window.handleSeeMoreBtn   = handleSeeMoreBtn;